import { render, staticRenderFns } from "./Editar.vue?vue&type=template&id=ec582906"
import script from "./Editar.vue?vue&type=script&lang=js"
export * from "./Editar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec582906')) {
      api.createRecord('ec582906', component.options)
    } else {
      api.reload('ec582906', component.options)
    }
    module.hot.accept("./Editar.vue?vue&type=template&id=ec582906", function () {
      api.rerender('ec582906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organizacion/aspectos/Editar.vue"
export default component.exports